<template>
  <div class="spl-select-order">
    <second-menu-link-content>
      <template v-slot:header>
        <span>选品单</span>
      </template>
      <template v-slot:content>
        <div class="main">
          <div class="search">
            <el-form ref="form" :model="form" label-width="90px">
              <el-form-item label="订单状态：" prop="state">
                <el-select v-model="form.state" clearable class="white">
                  <el-option
                    v-for="item in orderState"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名称：">
                <el-input class="white" v-model="form.name" placeholder="请输入商品名称"></el-input>
              </el-form-item>
              <el-form-item label="订单号：">
                <el-input class="white" v-model="form.code" placeholder="请输入订单号"></el-input>
              </el-form-item>
              <el-form-item label-width="16px">
                <el-button class="btn-blue" @click="searchData">筛选</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="table">
            <div class="table-title">
              <p class="order-detail">订单详情</p>
              <p class="order-commission">抽佣比例/金额</p>
              <p class="order-time">预计直播时间</p>
              <p class="order-state">订单状态</p>
              <p class="order-operation">操作</p>
            </div>
            <div class="table-list" v-for="(value,index) in orderData" :key="index">
              <div class="time-code">
                <p class="time">{{value.time}}</p>
                <p class="code">订单编号：{{value.code}}</p>
                <p class="address">收货信息：{{value.address}}</p>
              </div>
              <div class="order-content">
                <div class="goods-container">
                  <div class="goods-item" v-for="(item,i) in value.items" :key="i">
                    <div class="img-container">
                      <img class="img" :src="item.img" alt />
                    </div>
                    <div class="name-spec">
                      <p class="name">{{item.name}}</p>
                      <p class="spec">{{item.specifications}}</p>
                    </div>
                    <div class="price">￥{{item.price}}</div>
                    <div class="num">×{{item.quantity}}</div>
                  </div>
                </div>
                <div class="commission">
                  <div
                    class="item-commission"
                    v-for="(item,i) in value.items"
                    :key="i"
                  >{{item.commissionRate}}%/{{item.commissionPrice}}</div>
                </div>
                <div class="live-time">{{value.liveTime}}</div>
                <div class="state">{{value.statusName}}</div>
                <div class="operation">
                  <el-button
                    class="btn-blue"
                    v-if="value.status===1"
                    @click="checkOrder(value.id)"
                  >审核</el-button>
                  <el-button
                    class="btn-blue"
                    v-if="value.status===2"
                    @click="openInvitationDialog(value,0)"
                  >邀约</el-button>
                  <el-button
                    class="btn-blue"
                    v-if="value.status===3||value.status===4"
                    @click="openInvitationDialog(value,1)"
                  >编辑</el-button>
                  <el-button
                    class="btn-blue"
                    v-if="value.status===4"
                    @click="complete(value.id)"
                  >邀约完成</el-button>
                  <el-button
                    class="btn-blue"
                    v-if="value.status===7"
                    @click="openConfirmDialog(value)"
                  >直播确认</el-button>
                </div>
              </div>
            </div>
            <div class="nothing" v-show="orderData.length===0">暂无数据</div>
          </div>
          <div class="pagination">
            <pagination-tpl
              @queryChange="updatePage"
              :pageSize="pageSize"
              :currentPage="page"
              :total="total"
            ></pagination-tpl>
          </div>
          <el-dialog
            :title="invitationTitle"
            :visible.sync="invitationDialog"
            width="400px"
            top="25vh"
          >
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <el-form ref="invitationForm" :model="invitationForm" label-width="100px">
              <el-form-item label="寄样：" prop="isSend">
                <el-radio-group v-model="invitationForm.isSend">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="回寄：" prop="isReturn">
                <el-radio-group v-model="invitationForm.isReturn">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="产品说明：" prop="fileList">
                <el-upload
                  :class="invitationForm.fileList.length===0?'upload':'upload display'"
                  action="#"
                  :http-request="uploadExcel"
                  :on-remove="handleRemove"
                  :auto-upload="true"
                  multiple
                  :limit="1"
                  :file-list="invitationForm.fileList"
                >
                  <el-button size="small" type="primary" class="btn-blue">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">请上传产品相关的Excel文件,且不超过5M</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <div class="dialog-footer-btn">
              <el-button class="btn-white" @click="closeInvitationDialog">取消</el-button>
              <el-button class="btn-blue" @click="selectionInvite">保存</el-button>
            </div>
          </el-dialog>
          <el-dialog title="直播确认" :visible.sync="confirmDialog" width="450px" top="25vh">
            <!-- 黑色的线条 -->
            <div class="border"></div>
            <el-form ref="confirmForm" :model="confirmForm" label-width="100px">
              <el-form-item label="直播时间：">
                <span>{{confirmForm.time}}</span>
              </el-form-item>
              <el-form-item label="图片说明：">
                <el-image
                  style="width: 50px; height: 50px"
                  :src="confirmForm.img"
                  :preview-src-list="srcList"
                ></el-image>
                <p class="watch-img">点击图片查看缩略图</p>
              </el-form-item>
            </el-form>
            <div class="dialog-footer-btn">
              <el-button class="btn-white" @click="confirmDialog=false">取消</el-button>
              <el-button class="btn-blue" @click="submitConfirm">确定</el-button>
            </div>
          </el-dialog>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import Supplier from "models/spl/supplier.js";
import ImgUploader from "models/img-upload.js";
const supplier = new Supplier();
const imgUploader = new ImgUploader();
export default {
  data() {
    return {
      form: {
        state: "",
        name: "",
        code: "",
      },
      searchForm: {
        state: "",
        name: "",
        code: "",
      },
      orderState: [
        {
          value: 0,
          label: "拒绝",
        },
        {
          value: 1,
          label: "待审核",
        },
        {
          value: 2,
          label: "待邀约",
        },
        {
          value: 3,
          label: "待确认邀约",
        },
        {
          value: 4,
          label: "待完成",
        },
        {
          value: 5,
          label: "邀约完成",
        },
        {
          value: 6,
          label: "已取消",
        },
        {
          value: 7,
          label: "待直播确认",
        },
        {
          value: 8,
          label: "完成",
        },
      ],
      orderData: [],
      total: 0, // 数据总数量
      page: 1,
      pageSize: 20,
      //邀约
      invitationDialog: false,
      invitationTitle: "邀约",
      invitationForm: {
        id: "",
        isSend: 1,
        isReturn: 1,
        fileList: [],
      },
      //直播确定
      confirmDialog: false,
      confirmForm: {
        id: "",
        time: "",
        img: "",
      },
      srcList: [],
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
  created() {
    this.getOrderData();
  },
  methods: {
    getOrderData() {
      let status = this.searchForm.state;
      let goodsName = this.searchForm.name;
      let code = this.searchForm.code;
      let currentPage = this.page;
      let options = {
        status,
        goodsName,
        code,
        currentPage
      }
      supplier
        .getSupplierSelectionList(options)
        .then((res) => {
          if (res.success) {
            this.total = res.result.totalNum;
            let orderData = [];
            res.result.items.map((value) => {
              let obj = {};
              obj.id = value.id;
              obj.time = this.fmtDate(value.createTime);
              obj.liveTime = this.fmtDate(value.liveTime);
              obj.realTime =
                this.fmtDate(value.realStartTime) +
                "--" +
                this.fmtDate(value.realEndTime);
              obj.livePic = value.livePic;
              obj.code = value.code;
              obj.message = value.message;
              obj.address = value.address;
              obj.isReturn = value.isReturn;
              obj.isSend = value.isSend;
              obj.statusName = this.getCodeName(value.status);
              obj.status = value.status;
              obj.items = [];
              value.selectionOrderDetail.map((v) => {
                let object = {};
                object.img = v.goodsPic;
                object.name = v.goodsName;
                object.price = v.price;
                object.quantity = v.quantity;
                object.commissionRate = v.commissionRate * 100;
                object.commissionPrice = (v.commissionRate * v.price).toFixed(
                  2
                );
                let itemTitle = JSON.parse(v.itemTitle);
                let specifications = "";
                for (let key in itemTitle) {
                  specifications += `,${itemTitle[key]}`;
                }
                object.specifications = specifications.substring(1);
                obj.items.push(object);
              });
              orderData.push(obj);
            });
            this.orderData = orderData;
          }
        });
    },
    //搜索
    searchData() {
      this.searchForm = this.form;
      this.page = 1;
      this.getOrderData();
    },
    //审核订单
    checkOrder(id) {
      this.$confirm("是否通过该订单?", "审核", {
        confirmButtonText: "通过",
        cancelButtonText: "拒绝",
        distinguishCancelAndClose: true,
      })
        .then(() => {
          let status = 2;
          supplier.getSupplierSelectionApproval(id, status).then((res) => {
            if (res.success) {
              this.getOrderData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch((action) => {
          if (action === "cancel") {
            let status = 0;
            supplier.getSupplierSelectionApproval(id, status).then((res) => {
              if (res.success) {
                this.getOrderData();
              } else {
                this.$message.error(res.message);
              }
            });
          }
        });
    },
    //邀约弹窗
    openInvitationDialog(value, type) {
      if (type === 0) {
        this.invitationTitle = "邀约";
        this.invitationForm.id = value.id;
        this.invitationForm.isSend = 1;
        this.invitationForm.isReturn = 1;
        this.invitationForm.fileList = [];
        this.invitationForm.type = type;
      } else {
        this.invitationTitle = "编辑";
        this.invitationForm.id = value.id;
        this.invitationForm.isSend = value.isSend;
        this.invitationForm.isReturn = value.isReturn;
        this.invitationForm.fileList = [
          {
            name: "产品说明.xls",
            url: value.message,
          },
        ];
        this.invitationForm.type = type;
      }
      this.invitationDialog = true;
    },
    closeInvitationDialog() {
      this.invitationDialog = false;
      this.invitationForm.fileList = [];
    },
    uploadExcel(data) {
      let length = data.file.name.split(".").length;
      let type = data.file.name.split(".")[length - 1];
      const isEXCEL = type === "xlsx" || type === "xls";
      const isLt2M = data.file.size / 1024 / 1024 < 5;
      if (!isEXCEL) {
        this.$message.error("上传文件格式错误!");
        this.handleRemove();
        return false;
      } else if (!isLt2M) {
        this.$message.error("上传文件大小不能超过5MB!");
        this.handleRemove();
        // this.fileList = this.fileList.splice(1, )
        return false;
      } else {
        imgUploader
          .postImgUpload(data.file)
          .then((res) => {
            if (res.errorCode === 0) {
              let obj = {};
              obj.name = data.file.name;
              obj.url = res.imgUrl;
              this.invitationForm.fileList.push(obj);
            } else {
              this.$message.error("文件上传超时，请重新上传");
            }
          })
          .catch(() => {
            this.$message.error("文件上传超时，请重新上传");
          });
        return false;
        // console.log(file);
      }
    },
    //删除文件
    handleRemove(file, fileList) {
      this.invitationForm.fileList = [];
    },
    //确定邀约
    selectionInvite() {
      if (this.invitationForm.fileList.length > 0) {
        let data = {};
        data.id = this.invitationForm.id;
        data.isSend = this.invitationForm.isSend;
        data.isReturn = this.invitationForm.isReturn;
        data.message = this.invitationForm.fileList[0].url;
        if (this.invitationForm.type === 0) {
          supplier.postSupplierSelectionInvite(data).then((res) => {
            if (res.success) {
              this.closeInvitationDialog();
              this.getOrderData();
            }
          });
        } else {
          supplier.postSupplierUpdateInvite(data).then((res) => {
            if (res.success) {
              this.closeInvitationDialog();
              this.getOrderData();
            }
          });
        }
      } else {
        this.$message.error("请上传文件");
      }
      // if (this.invitationForm.content) {
      //   let data = {
      //     id: this.invitationForm.id,
      //     message: this.invitationForm.content,
      //   };
      //   if (this.invitationForm.status === 2) {
      //     supplier.postSupplierSelectionInvite(data).then((res) => {
      //       if (res.success) {
      //         this.closeInvitationDialog();
      //         this.getOrderData();
      //       }
      //     });
      //   } else {
      //     supplier.postSupplierUpdateInvite(data).then((res) => {
      //       if (res.success) {
      //         this.closeInvitationDialog();
      //         this.getOrderData();
      //       }
      //     });
      //   }
      // } else {
      //   this.$message.error("请输入邀约内容");
      // }
    },
    //邀约完成
    complete(id) {
      this.$confirm("是否确定该订单已邀约完成?", "邀约完成", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        distinguishCancelAndClose: true,
      }).then(() => {
        supplier.getSupplierSelectionFinish(id).then((res) => {
          if (res.success) {
            this.getOrderData();
          }
        });
      });
    },
    //直播确认弹窗
    openConfirmDialog(value) {
      this.confirmForm.time = value.realTime;
      this.confirmForm.id = value.id;
      this.confirmForm.img = value.livePic;
      let srcList = [];
      srcList.push(value.livePic);
      this.srcList = srcList;
      this.confirmDialog = true;
    },
    //直播确认
    submitConfirm() {
      let id = this.confirmForm.id;
      supplier.getSupplierSelectionEnd(id).then((res) => {
        if (res.success) {
          this.getOrderData();
          this.confirmDialog = false;
        }
      });
    },
    // 根据订单状态返回对应的值
    getCodeName(status) {
      let statusName = [
        "拒绝",
        "待审核",
        "待邀约",
        "待确认邀约",
        "待完成",
        "邀约完成",
        "已取消",
        "待直播确认",
        "完成",
      ];
      return statusName[status];
    },
    updatePage(data) {
      this.page = data.currentPage;
    },
    // 时间格式转换
    fmtDate(date) {
      let dateFn = new Date(date);
      let yy = dateFn.getFullYear();
      let mm = dateFn.getMonth() + 1;
      let dd = dateFn.getDate();
      let hh =
        dateFn.getHours() < 10
          ? "0" + dateFn.getHours()
          : "" + dateFn.getHours();
      let xx =
        dateFn.getMinutes() < 10
          ? "0" + dateFn.getMinutes()
          : "" + dateFn.getMinutes();
      let ss =
        dateFn.getSeconds() < 10
          ? "0" + dateFn.getSeconds()
          : "" + dateFn.getSeconds();
      let time = yy + "-" + mm + "-" + dd + " " + hh + ":" + xx + ":" + ss;
      return time;
    },
  },
};
</script>

<style lang="scss" scoped>
.spl-select-order {
  width: 100%;
  height: 100%;
  .main {
    .search {
      padding-top: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      margin-bottom: 16px;
      .el-form {
        display: flex;
        .el-input {
          width: 160px;
        }
        .el-select {
          width: 160px;
        }
      }
    }
    .table {
      .table-title {
        height: 32px;
        background: rgba(245, 247, 250, 1);
        border-radius: 4px 4px 0 0;
        display: flex;
        align-items: center;
        text-align: center;
        font-size: 14px;
        color: #888888;
        margin-bottom: 16px;
        .order-detail {
          width: 420px;
        }
        .order-commission {
          flex: 1;
        }
        .order-time {
          flex: 1;
        }
        .order-state {
          flex: 1;
        }
        .order-operation {
          flex: 1;
        }
      }
      .table-list {
        margin-bottom: 20px;
        .time-code {
          height: 34px;
          background: rgba(245, 247, 250, 1);
          border-radius: 4px 4px 0px 0px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: rgba(136, 136, 136, 1);
          padding-left: 20px;
          .time {
            margin-right: 20px;
          }
          .code {
            margin-right: 20px;
          }
        }
        .order-content {
          border: 1px solid #eff2f5;
          display: flex;
          .goods-container {
            width: 420px;
            border-right: 1px solid rgba(239, 242, 245, 1);
            .goods-item {
              margin: 6px 0;
              height: 70px;
              display: flex;
              align-items: center;
              padding-left: 20px;
              .img-container {
                width: 64px;
                height: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                .img {
                  max-width: 64px;
                  max-height: 64px;
                }
              }
              .name-spec {
                width: 198px;
                height: 50px;
                font-size: 14px;
                padding-left: 10px;
                box-sizing: border-box;
                .name {
                  height: 32px;
                  line-height: 16px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  margin-bottom: 2px;
                }
                .spec {
                  font-size: 13px;
                  height: 16px;
                  line-height: 16px;
                  color: #999999;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 1;
                }
              }
              .price {
                font-size: 12px;
                color: rgba(153, 153, 153, 1);
                padding-left: 14px;
                min-width: 64px;
              }
              .num {
                font-size: 12px;
                color: rgba(153, 153, 153, 1);
                padding-left: 10px;
              }
            }
          }
          .commission {
            flex: 1;
            border-right: 1px solid rgba(239, 242, 245, 1);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            .item-commission {
              height: 70px;
              line-height: 70px;
            }
          }
          .live-time {
            flex: 1;
            border-right: 1px solid rgba(239, 242, 245, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
          }
          .state {
            flex: 1;
            border-right: 1px solid rgba(239, 242, 245, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
          }
          .operation {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            .el-button {
              height: 24px;
              font-size: 12px;
            }
          }
        }
      }
      .table-list:last-child {
        margin-bottom: 0;
      }
      .nothing {
        height: 60px;
        line-height: 60px;
        color: #999;
        text-align: center;
        font-size: 14px;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
    }
    /deep/ .el-dialog {
      .el-dialog__body .el-form .el-form-item {
        margin-bottom: 16px;
        position: relative;
        .upload {
          .btn-blue {
            height: 24px;
            font-size: 12px;
          }
          .el-upload__tip {
            color: #c9c9c9;
            height: 16px;
            margin-top: 0;
            line-height: 16px;
            font-size: 12px;
          }
          .el-upload-list__item:first-child {
            margin-top: 5px;
          }
        }
        .display {
          .el-upload {
            display: none;
          }
          .el-upload__tip {
            display: none;
          }
        }
        .watch-img {
          position: absolute;
          top: 26px;
          left: 55px;
          font-size: 12px;
          color: rgba(201, 201, 201, 1);
        }
      }
      .dialog-footer-btn {
        border-top: 1px solid #eeeeee;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        padding-top: 20px;
        .el-button {
          height: 24px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
